import { createContext } from 'react';
var IconContext = /*#__PURE__*/createContext({});
var Context = IconContext;
export { Context as default };
//# sourceMappingURL=Context.js.map
